export function LabelWrapper({
  children,
  className = '',
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={`d-flex flex-row justify-content-between align-items-center ${className}`}
    >
      {children}
    </div>
  );
}
